import { render, staticRenderFns } from "./modalslide3.vue?vue&type=template&id=2150d615&scoped=true&"
import script from "./modalslide3.vue?vue&type=script&lang=js&"
export * from "./modalslide3.vue?vue&type=script&lang=js&"
import style0 from "./modalslide3.vue?vue&type=style&index=0&id=2150d615&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2150d615",
  null
  
)

export default component.exports